export const GET_CHECKLIST = 'GET_CHECKLIST';
export const LOADING_CHECKLIST = 'LOADING_CHECKLIST';
export const SAVE_LOADER_CHECKLIST = 'SAVE_LOADER_CHECKLIST';